import { from, type Observable } from "rxjs";
import type { NafRoutes, NafSectionSuggestion } from "shared";
import type { HttpClient } from "shared-routes";
import { otherwiseThrow } from "src/core-logic/adapters/otherwiseThrow";
import type { NafGateway } from "src/core-logic/ports/NafGateway";
import { match } from "ts-pattern";

export class HttpNafGateway implements NafGateway {
  constructor(private readonly httpClient: HttpClient<NafRoutes>) {}

  getAllNafSections$(): Observable<NafSectionSuggestion[]> {
    return from(
      this.httpClient.getAllNafSections().then((response) =>
        match(response)
          .with({ status: 200 }, ({ body }) => body)
          .otherwise(otherwiseThrow),
      ),
    );
  }
}
